import React from 'react';
import { Offcanvas } from 'reactstrap';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { ErrorView } from '../../../common/views/ErrorView/ErrorView';
import { useContactDetail } from '../hooks/useContactDetail';
import { ContactDrawerBody } from './ContactDrawerBody';
/* eslint-disable css-modules/no-unused-class -- the drawer shares the Find drawer look */
import findStyles from '../find/Find.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ContactDrawerProps {
  accountId: number;
  workspaceContactUuid: string | null;
  onClose: () => void;
}

/** The contact drawer over Contacts (design outreach q2). */
const ContactDrawerComponent: React.FC<ContactDrawerProps> = ({ accountId, workspaceContactUuid, onClose }) => {
  const { detail, isLoading, error, retry } = useContactDetail(accountId, workspaceContactUuid);
  return (
    <Offcanvas isOpen={workspaceContactUuid !== null} toggle={onClose} direction="end" className={findStyles.drawer}>
      <div className={findStyles.drawerInner} data-testid="contact-drawer">
        {isLoading && <LoadingView />}
        {!isLoading && error !== null && <ErrorView error={error ?? undefined} retry={retry} />}
        {detail !== undefined && <ContactDrawerBody accountId={accountId} detail={detail} onClose={onClose} />}
      </div>
    </Offcanvas>
  );
};

export const ContactDrawer = TypedMemo(ContactDrawerComponent);
